import React from 'react';
import styles from './PartySizeGrid.module.css';

interface PartySizeGridProps {
  selectedSize: number;
  onSelect: (size: number) => void;
}

const SIZES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

/**
 * 인원수 선택 그리드 (1~9, 10+)
 */
export function PartySizeGrid({ selectedSize, onSelect }: PartySizeGridProps) {
  return (
    <div className={styles.grid}>
      {SIZES.map((size) => {
        const isSelected = selectedSize === size;
        const label = size === 10 ? '10+' : String(size);

        return (
          <button
            key={size}
            className={isSelected ? styles.selected : styles.sizeButton}
            onClick={() => onSelect(size)}
            type="button"
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
